import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { GetWidgetsService } from '../../get-widgets.service';
import { NotificationsService } from 'angular2-notifications';
import { Subscription } from 'rxjs/Subscription';
import { MatDialog } from '@angular/material/dialog';import { SearchFilters } from '../../../dashboard/search-panel/search-panel.model';
import { EnlargeGetDashboardWidgetComponent } from '../enlarge-get-dashboard-widget/enlarge-get-dashboard-widget.component';

@Component({
  selector: 'app-inspection-count-per-jobsite-widget',
  templateUrl: './inspection-count-per-jobsite-widget.component.html',
  styleUrls: ['./inspection-count-per-jobsite-widget.component.scss']
})
export class InspectionCountPerJobsiteWidgetComponent implements OnInit {

  @Input() chartid: string;
    
  @Input() passedDataSource : any;
  @Input() isInPopup: boolean = false;
  dataSource: any;
  width: number = 350;
  height: number = 180;
  type = "scrollbar2d";
  dataFormat = "json";
  subscriptions: Subscription[] = [];
  noData: boolean = false;
  loading: boolean = true;
  // Search Parameters
  @Input() searchParameters: SearchFilters = new SearchFilters();

  constructor(private _widgets: GetWidgetsService,
    private _notification: NotificationsService,
    private _dialog: MatDialog) {
    this.dataSource = {
      chart: {
        // caption: "Budget Performance against Budget",
        // xaxisname: "Bucket",
        // yaxisname: "hrs",

        plottooltext:
          "<b>$label</b> performed <b>$dataValue</b>",
        theme: "fusion",
        // labelDisplay: "rotate",
        plotSpacePercent: '50',
        alignCaptionWithCanvas: "0",
        paletteColors: "#f2726f",
      },
      categories: [
        {
          category: []
        }
      ],
      dataset: [
        {
              data: []
          
        }
      ]
    };




  }

  ngOnInit() {

    if(this.passedDataSource != null ){
      console.log("received   ", this.passedDataSource);
      this.loading=false;
        if (this.passedDataSource.JobsiteLits != null || this.passedDataSource.JobsiteLits.length > 0) {
          this.dataSource.categories[0].category = this.passedDataSource.JobsiteLits;
          this.dataSource.dataset[0].data = this.passedDataSource.InspectionCount;
          this.type = "scrollbar2d";
          this.width = 600;
          this.height = 450;
          this.loading = false;
        }else{
          this.loading = true;
          this.noData=true;
        }
      
    }
    else{
      var params: SearchFilters = {
        customer: this.searchParameters.customer,
        jobsite: this.searchParameters.jobsite,
        equipment: this.searchParameters.equipment,
        make: this.searchParameters.make,
        makeUC: this.searchParameters.makeUC,
        

        model: this.searchParameters.model,
        implement: this.searchParameters.implement,
        ImplementTypes: this.searchParameters.ImplementTypes,
        ComponentTypes: this.searchParameters.ComponentTypes,

        onEq: this.searchParameters.onEq,
        evalA: false,
        evalB: false,
        evalC: false,
        evalX: false,
        NoImps: false,
        family: this.searchParameters.family,
        assetSerial: this.searchParameters.assetSerial,
        GETType: this.searchParameters.GETType,
        PageNumber: 0,
        PageSize: 0
      };
  
      this._widgets.GetInspectionCarriedOut(params).subscribe(res => {
        console.log("data__", res)
  
        this.dataSourceToPass=res;
        this.loading=false;
  
        if (res.JobsiteLits != null || res.JobsiteLits.length > 0) {
          this.dataSource.categories[0].category = res.JobsiteLits;
          this.dataSource.dataset[0].data = res.InspectionCount;
          this.loading = false;
        }else{
          this.loading = true;
          this.noData=true;
        }
        
  
       
      })
    }


    
  
  }

  dataSourceToPass :any;
  openWithANewPopup(){
        let dialogRef = this._dialog.open(EnlargeGetDashboardWidgetComponent, {
            panelClass: 'removeModalOverflow',
            data: {
              chartId: 2,
              dataSource: this.dataSourceToPass,
              chartTitle: "Inspections Performed",     
            }
          });
      
          dialogRef.afterClosed().subscribe(r => {
      
          });
      }

}
